import { useState } from 'react';
import apiService from '../../axios/apiService';
import { saveAs } from 'file-saver';
import { getBlobFromBase64 } from '../../utils/file';

export const useDownloadInvoicePreview = () => {
  const [loading, setLoading] = useState(false);
  const getCaseReportPreview = async (invoiceId, invoiceNo) => {
    // Fetch case
    setLoading(true);
    try {
      const response = await apiService.downloadInvoicePreview(invoiceId);
      if (response) {
        const blob = await getBlobFromBase64(response, 'application/pdf');
        saveAs(blob, `${invoiceNo}.pdf`);
      }
    } catch (error) {
      console.log('Error: ', error);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    getCaseReportPreview,
  };
};
